// extracted by mini-css-extract-plugin
module.exports = {"text":"text_text__o126J","alignment--left":"text_alignment--left__yjnG1","alignment--center":"text_alignment--center__TPSFp","alignment--right":"text_alignment--right___PFcp"};